import styled from "styled-components";

export const CardContainer = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const FlexContainer = styled.div<{ img: string }>`
  min-height: 873px;
  height: 100vh;
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const GridContainer = styled.div<{ img: string }>`
  min-height: 873px;
  height: 100vh;
  background-image: url(${(props) => props.img});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;
  display: grid;
  grid-template-rows: 1fr 1fr;
  text-align: center;
`;

export const GridSection = styled.section`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 20px;
  @media (max-width: 768px) {
    font-size: 1.3rem;
    margin-bottom: 20px;
  }
`;
export const Description = styled.span`
  text-align: center;
  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const Cards = styled.div<{ grid_childs_number: number }>`
    width: 100%;
  display: grid;
  grid-template-columns: repeat(${props=>props.grid_childs_number}, 1fr);
`;

export const Card = styled.div<{ index: number }>`
  position: relative;
  display: flex;
  padding: 10px 7%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  & h1 {
    font-weight: 600;
    font-size: .9rem;
    margin: 1rem;
  }
  & span {
    max-width: 400px;
    font-size: 0.7rem;
    padding : 0 12px;
  }
  @media (max-width: 768px) {
    padding: 0 12%;
  }
`;

export const CardDownLoadBtn = styled.a`
position: relative;
margin-top : 40px;
margin-bottom: 10px;
padding : 20px 40px;
border: solid 0.6px ${(props) => props.theme.textColor_base};
border-radius: 50%;
display: flex;
align-items: center;
justify-content: center;
text-align: center;
transition: all 1s;
font-size: 0.8rem;
font-weight: 500;
@media ( max-width: 1650px) {
  margin-top : 20px;
margin-bottom: 30px;
}
@media (max-width: 768px) {
    padding: 16px 28px;
    font-size: 0.65rem;
  }
`;
